import React from 'react'
import { Button } from '../../ui/button'
import { ArrowLeft, ArrowRight } from 'lucide-react'

interface NavigationButtonsProps {
  canGoBack: boolean
  hasAnswered: boolean
  isLastQuestion: boolean
  onPrevious: () => void
  onNext: () => void
  showPreviousSection?: boolean
  showNextSection?: boolean
  hasExistingResponses?: boolean
}

export function NavigationButtons({ 
  canGoBack, 
  hasAnswered, 
  isLastQuestion,
  onPrevious, 
  onNext,
  hasExistingResponses = false
}: NavigationButtonsProps) {
  return (
    <div className="flex justify-between gap-2">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={!canGoBack}
        className="flex items-center gap-2 min-w-[100px]"
      >
        <ArrowLeft className="w-4 h-4" />
        Previous
      </Button>
      <Button
        onClick={onNext}
        disabled={!hasAnswered}
        className="flex items-center gap-2 min-w-[100px]"
      >
        {isLastQuestion ? (
          'Submit'
        ) : (
          <>Next <ArrowRight className="w-4 h-4" /></>
        )}
      </Button>
    </div>
  )
}